import React from 'react'
import { Outlet } from 'react-router-dom'

function Web() {
  return (
    <Outlet/>
  )
}

export default Web